export function openInNewTab (url: string | URL): void {
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function reloadPage (): void {
  window.location.reload()
}
